import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";
import { FornecedorLista } from "../../../../domain/models/fornecedor";

/**
 * GenerateFornecedoresListaColumnDefinition
 */

type Props = {
  onActionEditar: (idFornecedor: number | null, openNewTab: boolean) => void;
  onActionDeletar: (idFornecedor: number | null, openState: boolean) => void;
};

export const GenerateFornecedoresListaColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  // Documentos

  const computeDocumentosStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Em Dia";
      case 2:
        return "Vencidos";
      case 3:
        return "Não possui";
      default:
        return "?";
    }
  };

  const computeDocumentosStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 2:
        return "red";
      case 3:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeDocumentosStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Documentos Em Dia";
      case 2:
        return "Documentos Vencidos";
      case 3:
        return "Não possui Documentos";
      default:
        return "?";
    }
  };

  // Qualificado

  const computeQualificadoTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Sim";
      case 0:
        return "Não";
      default:
        return "?";
    }
  };

  const computeQualificadoColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeQualificadoDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Sim";
      case 0:
        return "Não";
      default:
        return "?";
    }
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 60,
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "nroFornecedor",
      filterable: false,
      headerName: "Código",
      headerAlign: "center",
      width: 65,
      minWidth: 65,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "statusDocumentos",
      filterable: false,
      headerName: "Documentos",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={computeDocumentosStatusTitle(params.value)}
            color={computeDocumentosStatusColor(params.value)}
            description={computeDocumentosStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "desqualificado",
      filterable: false,
      headerName: "Qualificado?",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeQualificadoTitle(params.value ? 0 : 1)}
            color={computeQualificadoColor(params.value ? 0 : 1)}
            description={computeQualificadoDescription(params.value ? 0 : 1)} />
        </div>
      )
    },
    {
      field: "notaMedia",
      filterable: false,
      headerName: "Nota Média",
      width: 80,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <>
            {
              (value !== null && value !== undefined) &&
              <div className="size-full flex flex-col justify-center items-center">
                <span
                  className="w-[2.5rem] h-[1.4rem] bg-[#89c4f4] text-white flex flex-col justify-center items-center rounded"
                  style={{ textShadow: '-1px -1px 0 #444, 1px -1px 0 #444, -1px 1px 0 #444, 1px 1px 0 #444' }}>
                  {value}
                </span>
              </div>
            }
          </>
        );
      }
    },

    {
      field: "tipoFornecedor",
      filterable: false,
      headerName: "Tipo",
      description: "P: Produtos; S: Serviços; PS: Produtos e serviços",
      width: 55,
      minWidth: 55,
      sortable: false,
      valueGetter: (_, row: FornecedorLista) =>
        row.fornProduto ? (row.fornServico ? "PS" : "P") : (row.fornServico ? "S" : "NA"),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={value}
            color={value === "P" ? "green" : value === "S" ? "blue" : value === "PS" ? "yellow" : "gray"}
            description={value === "PS" ? "Produtos e serviços" : value === "P" ? "Produtos" : value === "S" ? "Serviços" : "Não se aplica"} />
        </div>
      ),
    },
    {
      field: "nomeFantasia",
      filterable: false,
      headerName: "Nome Fantasia",
      flex: 2,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "razaoSocial",
      filterable: false,
      headerName: "Razão Social",
      flex: 2,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "familia",
      filterable: false,
      headerName: "Família",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data Cadastro",
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
            {value && dayjs(value).format('DD/MM/YYYY')}
          </div>
        );
      },
    },
    {
      field: 'idFornecedor',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEditar(params.value, true);
                } else {
                  onActionEditar(params.value, e.ctrlKey);
                }
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}
